import { css } from 'styled-components'

export const reset = css`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  svg {
    display: block;
  }

  .gatsby-image-wrapper {
    height: 100%;
    width: 100%;
  }
`
